import { useContext } from 'react'; 
import SettingsContext from 'src/ThemeComponents/contexts/SettingsContext';
import type { SettingsContextValue } from 'src/ThemeComponents/contexts/SettingsContext';

const useSettings = (): SettingsContextValue => useContext(SettingsContext);

export default useSettings;
